import { cn } from "@-/com.npmjs.cn";
import { View } from "@-/com.npmjs.react-native";

/**
 * The small unread marker beside a menu row, or pinned to a corner of the button that opens that
 * menu. Purely visual: it never takes touches or accessibility focus, so the control it decorates
 * must announce the unread state itself (e.g. `accessibilityValue={{ text: "New" }}`).
 */
export function NotificationDot({ className, testID }: { className?: string; testID?: string }) {
  return (
    <View
      accessibilityElementsHidden
      className={cn("size-2.5 rounded-full bg-destructive", className)}
      importantForAccessibility="no-hide-descendants"
      pointerEvents="none"
      testID={testID}
    />
  );
}
